module.exports = "/_next/static/images/876149ec768b015ef90cd1078cdbc94f-sanpablo-3.jpg.webp";